import { useEffect, useState } from 'react'
import { fetchUploadLimits, type UploadLimits } from '../lib/uploads'

// The API's upload limits, or null until they load (or if the request fails)
export function useUploadLimits(): UploadLimits | null {
  const [limits, setLimits] = useState<UploadLimits | null>(null)

  useEffect(() => {
    let active = true
    fetchUploadLimits()
      .then(result => {
        if (active) {
          setLimits(result)
        }
      })
      .catch(() => {})
    return () => {
      active = false
    }
  }, [])

  return limits
}
